import { FunctionComponent, useEffect, useState } from 'react';
import { getVelocityData } from '../data/mockData';
import styles from './AcquisitionVelocity.module.scss';
import ClientMovementChart from './charts/ClientMovementChart';
import VelocityCohortTable from './VelocityCohortTable';

interface AcquisitionVelocityProps {
    description?: string;
}

export const AcquisitionVelocity: FunctionComponent<AcquisitionVelocityProps> = props => {
    const [loading, setLoading] = useState(true);

    const data = getVelocityData();

    useEffect(() => {
        const timeout = setTimeout(() => setLoading(false), 600);
        return () => clearTimeout(timeout);
    }, []);

    return (
        <div className={styles.container}>
            <span className={styles.description}>{props.description}</span>

            <div className={styles.section}>
                <h3 className={styles.sectionTitle}>Monthly Cohorts · 2026</h3>
                <VelocityCohortTable
                    data={data}
                    loading={loading}
                />
            </div>

            <div className={styles.section}>
                <h3 className={styles.sectionTitle}>Client Movement · Net of Churn</h3>
                <p className={styles.sectionHint}>
                    New clients (up) vs. lost clients (down) each month, with total active clients as the trend line.
                </p>
                <div className={styles.chartCard}>
                    <ClientMovementChart
                        movement={data.movement}
                        loading={loading}
                    />
                </div>
            </div>
        </div>
    );
};

export default AcquisitionVelocity;
